import { render, staticRenderFns } from "./EditFichaLima.vue?vue&type=template&id=127d805d"
import script from "./EditFichaLima.vue?vue&type=script&lang=js"
export * from "./EditFichaLima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports